
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-dich-vu",
      function () {
        return require("private-next-pages/goi-dich-vu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-dich-vu"])
      });
    }
  